module.exports = __webpack_public_path__ + "static/img/select.8ea63827.png";